import {Tracking} from "../tracking/tracking";

type IPinitDefaultSettings = {
  buttonUrl: string;
  callback?: (wrap: HTMLDivElement) => void;
  class: string;
  ignore: string;
  minHeight: number;
  minWidth: number;
  selector: string;
};

type IPinitParamSettings = Partial<IPinitDefaultSettings>;

const defaults: IPinitDefaultSettings = {
  buttonUrl: "/images/pinit_icon.png",
  class: "pinit--wrap",
  ignore: ".pinit-ignore",
  minHeight: 5,
  minWidth: 5,
  selector: "img",
};

export default class PinitComponent {
  public static pinit(image: HTMLImageElement | HTMLElement, options?: IPinitParamSettings): void {
    const settings = {...defaults, ...(options || {})};
    let images: HTMLImageElement[];
    if (image instanceof HTMLImageElement) {
      images = [image];
    } else {
      images = Array.from(image.querySelectorAll(settings.selector)).filter<HTMLImageElement>(
        (img): img is HTMLImageElement => !img.matches(settings.ignore),
      );
    }

    const isIos = /(iphone|ipod|ipad)/.exec(navigator.userAgent.toLowerCase());
    const isAbsoluteURL = new RegExp("^(?:[a-z]+:)?//", "i");

    function pinitRender(img: HTMLImageElement) {
      if (img.dataset.pinit !== undefined || img.height < settings.minHeight || img.width < settings.minWidth) {
        return;
      }

      let imgURL = img.dataset.pinitImage || img.src;
      const hOne = document.querySelector("h1");
      const title = img.dataset.pinitTitle || hOne?.innerText || "";

      const wrap = document.createElement("div");
      wrap.setAttribute("class", settings.class);
      wrap.style.position = "relative";
      wrap.style.display = "inline-block";
      wrap.className += ` ${img.className}`;

      imgURL = isAbsoluteURL.test(imgURL)
        ? imgURL
        : window.location.protocol + "//" + window.location.hostname + imgURL;

      let shareURL = "https://www.pinterest.com/pin/create/button/?url=" + encodeURIComponent(document.URL);
      shareURL += "&media=" + encodeURIComponent(imgURL);
      shareURL += "&description=" + encodeURIComponent(title);

      let pinButton: HTMLAnchorElement | HTMLSpanElement;
      if (isIos) {
        pinButton = document.createElement("a");
        pinButton.setAttribute("class", "pin-it");
        pinButton.setAttribute("href", shareURL);
        pinButton.setAttribute("target", "_blank");
      } else {
        pinButton = document.createElement("span");
        pinButton.setAttribute("class", "pin-it");
        pinButton.addEventListener("click", (e) => {
          window.open(shareURL, "_blank", "width=700, height=300");
          const heins = document.querySelector("h1");
          Tracking.setVariable("PinterestEventTitle", heins !== null ? heins.innerText : "Content of Connox design");
          Tracking.sendEvent("ShareToPinterest");
          e.preventDefault();
        });
      }

      pinButton.style.opacity = "0";

      const pinImg = document.createElement("img");
      pinImg.setAttribute("src", settings.buttonUrl);

      const imgClone = img.cloneNode() as HTMLImageElement;
      imgClone.className = "";
      imgClone.dataset.pinit = "true";

      pinButton.appendChild(pinImg);
      wrap.appendChild(pinButton);
      wrap.appendChild(imgClone);

      const parent = img.parentElement as HTMLElement;
      parent.removeChild(img);
      parent.appendChild(wrap);

      pinButton.style.opacity = "";
    }

    function pinitAfterComplete(imageToRender: HTMLImageElement) {
      if (imageToRender.complete && imageToRender.src !== window.location.href) {
        pinitRender(imageToRender);
      } else if (imageToRender.getAttribute("loading") === "lazy") {
        imageToRender.classList.add("pinit-ignore");
        imageToRender.addEventListener("load", (evt: Event) => pinitRender(evt.target as HTMLImageElement));
      }
    }

    images.forEach((img) => {
      pinitAfterComplete(img);
    });
  }
}
